import { Component, OnChanges, SimpleChanges, inject, input } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ResearchUnitsService } from '../research-units.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AcademicUnitPortalDTO } from '../../shared/external-model/academicunit/academic-unit-portal-dto';
import { SearchEntities } from '../../shared/configurations/portal-search.constant';
import { State } from '../../shared/configurations/state.constant';
import { TranslateObjectPipe } from '../../shared/pipes/translate-object.pipe';
import { ExpandableComponent, SeparatorComponent } from '@exl-ng/mulo-common';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { SvgViewboxDirective } from '@exl-ng/mulo-core';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor, MatIconButton } from '@angular/material/button';
import { CenteredBlockLayoutComponent } from '@exl-ng/mulo-views';

@Component({
    selector: 'esp-research-unit-header',
    templateUrl: './research-unit-header.component.html',
    styleUrls: ['./research-unit-header.component.scss'],
    imports: [
        CenteredBlockLayoutComponent,
        MatAnchor,
        RouterLink,
        MatIcon,
        SvgViewboxDirective,
        MatIconButton,
        MatMenuTrigger,
        MatMenu,
        MatMenuItem,
        ExpandableComponent,
        SeparatorComponent,
        TranslateModule,
        TranslateObjectPipe,
    ]
})
export class ResearchUnitHeaderComponent implements OnChanges {
    private route = inject(ActivatedRoute);
    private unitsSvc = inject(ResearchUnitsService);
    private translate = inject(TranslateService);

    readonly unitCode = input<string>(undefined);
    readonly activeEntity = input<string>(undefined);
    unit: AcademicUnitPortalDTO;
    logos = [];
    descriptions = [];
    links = [];
    breadcrumbsArray = [];
    firstLevelSubUnits = [];

    ngOnChanges(changes: SimpleChanges) {
        const unitCode = changes['unitCode']?.currentValue;
        if (unitCode) {
            this.unitsSvc.getResearchUnitByCode(unitCode).subscribe((res) => {
                this.unit = res;
                this.unitsSvc
                    .getResearchUnitFiles(this.unit.id)
                    .subscribe((res) => {
                        this.logos = res.filter(
                            (_) => _.contentType === 'academicUnit.logo',
                        );
                    });
                this.unitsSvc
                    .getResearchUnitLinks(this.unit.id)
                    .subscribe((res) => {
                        this.links = res.filter(
                            (_) => _.contentType === 'academicUnit.banner',
                        );
                    });
                this.unitsSvc
                    .getResearchUnitDescriptions(this.unit.id)
                    .subscribe((res) => {
                        this.descriptions = res.filter(
                            (_) => _.type === 'academicUnit.banner',
                        );
                    });
            });
            this.unitsSvc.getOrgAncestors(unitCode).subscribe((res) => {
                this.breadcrumbsArray = res ? (res as String[]) : [];
                this.breadcrumbsArray.reverse();
                this.breadcrumbsArray.shift();
                this.breadcrumbsArray.pop();
            });
            this.unitsSvc
                .getOrgFirstLevelSubUnits(unitCode)
                .subscribe((data) => {
                    this.firstLevelSubUnits = data ? (data as String[]) : [];
                    this.translate.get('key').subscribe((data) => {
                        this.firstLevelSubUnits.sort((a, b) =>
                            this.unitsSvc.alphabeticallySortAfterTranslation(
                                a,
                                b,
                            ),
                        );
                    });
                });
        }
    }

    unitLinkQueryParams(unitCode = this.unitCode()) {
        return this.unitsSvc.unitLinkQueryParams(unitCode, this.activeEntity());
    }

    unitSearchLink(unitCode = this.unitCode()) {
        switch (this.activeEntity()) {
            case SearchEntities.RESEARCHERS_ENTITY:
                return [State.RESEARCHERS_SEARCH];
            case SearchEntities.OUTPUTS_ENTITY:
                return [State.OUTPUTS_SEARCH];
            case SearchEntities.PROJECTS_ENTITY:
                return [State.PROJECTS_SEARCH];
            default:
                return ['/research-units/', unitCode];
        }
    }
}
